import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// M-04: Self-hosted Cairo font — eliminates Google Fonts CDN dependency and GDPR concern.
// Fonts are bundled by webpack at build time; no external network request at runtime.
import '@fontsource/cairo/400.css';
import '@fontsource/cairo/500.css';
import '@fontsource/cairo/600.css';
import '@fontsource/cairo/700.css';
import '@fontsource/cairo/800.css';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

register();
